export default Vue.extend({
  props: {
    initialCategories: {
      type: Array,
      default() {
        return []
      }
    },
    selectedCategoryId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      categories: this.initialCategories,
      loading: this.initialCategories.length === 0,
      searchValue: ''
    }
  },

  created() {
    if (this.categories.length === 0) this.loadCategories()
  },

  computed: {
    filteredCategories() {
      const keyword = this.searchValue.trim().toLowerCase()
      if (!keyword) return this.categories
      return this.categories.filter((category) => {
        return String(category.name || '').toLowerCase().indexOf(keyword) >= 0
      })
    }
  },

  template: `
    <div class="sidebar-organization sidebar-categories" data-has-navigator>
      <div class="input-control left-addon">
        <input type="text"
               class="controlled-input floated"
               v-model.trim="searchValue"
               placeholder="搜索分类">
        <div class="addon">
          <i class="slp-search"></i>
        </div>
      </div>

      <div class="search-list" v-if="searchValue">
        <div class="categories-search-list">
          <div class="list-title">分类</div>
          <div v-if="loading" class="sidebar-tip">加载中...</div>
          <div v-else-if="filteredCategories.length === 0" class="sidebar-tip">没有匹配的分类</div>
          <div v-else class="categories-search-wrapper">
            <div v-for="category in filteredCategories"
                 :key="category.id"
                 :class="['list-item category-sidebar-item', { selected: String(category.id) === String(selectedCategoryId) }]"
                 @click="visitCategory(category)">
              <span class="category-sidebar-icon">
                <i v-if="category.hidden" class="fa fa-eye-slash"></i>
                <i v-else-if="category.icon" :class="'fa ' + category.icon"></i>
                <i v-else class="fa fa-folder-o"></i>
              </span>
              <span class="text-ellipsis">{{ category.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="sidebar-content" v-else>
        <div class="list">
          <div class="list-title">分类</div>
          <div class="content">
            <div :class="['list-item category-sidebar-item', { selected: !selectedCategoryId }]"
                 @click="visitIndex">
              <span class="category-sidebar-icon">
                <i class="fa fa-folder-open-o"></i>
              </span>
              <span>所有分类</span>
              <span class="sidebar-count">{{ categories.length }}</span>
            </div>
          </div>
        </div>

        <div class="organizations-list categories-tree-list">
          <div class="list-head">
            <div class="list-title">顶级分类</div>
          </div>
          <div class="list-body">
            <div v-if="loading" class="sidebar-tip">加载中...</div>
            <div v-else-if="categories.length === 0" class="sidebar-tip">暂无分类</div>
            <div v-else class="categories-list">
              <div v-for="category in categories"
                   :key="category.id"
                   :class="['list-item category-sidebar-item', { selected: String(category.id) === String(selectedCategoryId) }]"
                   @click="visitCategory(category)">
                <span class="category-sidebar-icon">
                  <i v-if="category.hidden" class="fa fa-eye-slash"></i>
                  <i v-else-if="category.icon" :class="'fa ' + category.icon"></i>
                  <i v-else class="fa fa-folder-o"></i>
                </span>
                <span class="text-ellipsis">{{ category.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  methods: {
    categoryPath(category) {
      return category.urls && category.urls.show ? category.urls.show : `/admin/categories/${category.id}`
    },

    visitIndex() {
      Turbolinks.visit('/admin/categories')
    },

    visitCategory(category) {
      Turbolinks.visit(this.categoryPath(category))
    },

    loadCategories() {
      this.loading = true
      Skylark.Libs.Ajax.get('/admin/categories.json', {
        responseType: 'json',
        success: (categories) => {
          this.categories = categories
        },
        complete: () => {
          this.loading = false
        }
      })
    }
  }
})
